import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "text", "id", "tooltipStyleOverrides", "tooltipArrowStyleOverrides", "tooltipContentStyleOverrides", "arrowPosition", "closeButton"];
import styled, { css } from 'foundations-theming-specialty/utils';
import { SIMPLE_PLACEMENT } from '../types/placement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledToolTip = styled.div.withConfig({
  displayName: "Tooltip__StyledToolTip",
  componentId: "u9cqpx-0"
})(({
  position,
  theme
}) => {
  return css(["position:absolute;transform:translateX(-50%);background-color:", ";color:", ";", ""], theme.color['global-shell-fill-surface-panel-default'], theme.color['text-core-on-fill-default'], (() => {
    switch (position) {
      case SIMPLE_PLACEMENT.NONE:
        return css(["top:3px;"]);
      case SIMPLE_PLACEMENT.BOTTOM:
        return css(["bottom:calc(100% - 8px);margin-bottom:15px;"]);
      case SIMPLE_PLACEMENT.LEFT:
        return css(["top:-8px;margin-left:15px;transform:translateX(0) translateY(calc(-50% + 10px));"]);
      case SIMPLE_PLACEMENT.RIGHT:
        return css(["top:-8px;margin-right:15px;transform:translateX(calc(-100% - 10px)) translateY(calc(-50% + 10px));"]);
      case SIMPLE_PLACEMENT.TOP:
      default:
        return css(["margin-top:15px;"]);
    }
  })());
});
const StyledContent = styled.div.withConfig({
  displayName: "Tooltip__StyledContent",
  componentId: "u9cqpx-1"
})(({
  $titled,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["width:", ";padding:", ";border-radius:", ";transform:rotate(0deg);", ";"], $titled ? '360px' : '260px', $titled ? '18px' : '12px 18px', theme.borderRadius['100'], theme.typography['body-100']);
});
const StyledArrow = styled.div.withConfig({
  displayName: "Tooltip__StyledArrow",
  componentId: "u9cqpx-2"
})(({
  position,
  theme
}) => {
  return css(["position:absolute;width:20px;height:20px;transform:rotate(45deg) translateX(-50%);z-index:1;transform-origin:center;background-color:", ";", ""], theme.color['global-shell-fill-surface-panel-default'], (() => {
    switch (position) {
      case SIMPLE_PLACEMENT.NONE:
        return `
          display: none
        `;
      case SIMPLE_PLACEMENT.BOTTOM:
        return `
        top: calc(100% - 4.14px);
        left: 50%;
        border-right: 1px solid ${theme.color['global-shell-border-default']};
        border-bottom: 1px solid ${theme.color['global-shell-border-default']};
        `;
      case SIMPLE_PLACEMENT.LEFT:
        return `
        top: calc(50% - 5px);
        left: -3px;
        border-left: 1px solid ${theme.color['global-shell-border-default']};
        border-bottom: 1px solid ${theme.color['global-shell-border-default']};
        `;
      case SIMPLE_PLACEMENT.RIGHT:
        return `
          top: calc(50% - 5px);
          left: calc(100% - 3px);
          border-top: 1px solid ${theme.color['global-shell-border-default']};
          border-right: 1px solid ${theme.color['global-shell-border-default']};
        `;
      case SIMPLE_PLACEMENT.TOP:
      default:
        return `
        top: -3px;
        left: calc(50% - 4.14px);
        border-left: 1px solid ${theme.color['global-shell-border-default']};
        border-top: 1px solid ${theme.color['global-shell-border-default']};
        `;
    }
  })());
});
const StyledTitle = styled.h5.withConfig({
  displayName: "Tooltip__StyledTitle",
  componentId: "u9cqpx-3"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["margin-bottom:", ";", ";"], theme.space['200'], theme.typography['heading-25']);
});
export const ToolTip = _ref => {
  let {
      title,
      text,
      id,
      tooltipStyleOverrides,
      tooltipArrowStyleOverrides,
      tooltipContentStyleOverrides,
      arrowPosition = 'top',
      closeButton
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledToolTip, Object.assign({
    position: arrowPosition,
    style: tooltipStyleOverrides,
    id: id,
    "data-test-id": id,
    role: "tooltip",
    "aria-live": "polite"
  }, otherProps, {
    children: [/*#__PURE__*/_jsx(StyledArrow, {
      position: arrowPosition,
      style: tooltipArrowStyleOverrides,
      id: `${id}-arrow`,
      "data-test-id": `${id}-arrow`
    }), /*#__PURE__*/_jsxs(StyledContent, {
      style: tooltipContentStyleOverrides,
      id: `${id}-content`,
      "data-test-id": `${id}-content`,
      $titled: !!title,
      children: [closeButton, title && /*#__PURE__*/_jsx(StyledTitle, {
        children: title
      }), text]
    })]
  }));
};